import { mapState, mapGetters, mapActions } from 'vuex'

export const adminListComputed = {
  ...mapState('adminList', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('adminList', ['getAdminList']),
}

export const adminListMethods = mapActions('adminList', [
  'fetchingAdminList',
  'resetAdminList',
])
